/*
 *  -----------------------------------------------------------------------
 *    <copyright file="delete-visit-warning/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import React from 'react';

import { IProps } from '@components/admin/delete-visit-warning/delete-visit-warning.interface';
import { useTranslation } from 'hooks';
import { CustomDialog, DialogTitle } from 'views/components/core/dialog';
import './styles.scss';

const DeleteVisitWarningDialog = ({ open, onClose }: IProps) => {
    const { t } = useTranslation();

    return (
        <CustomDialog
            onClose={onClose}
            fullWidth
            scroll="paper"
            maxWidth="md"
            open={open}
            className="custom-width-popup"
        >
            <DialogTitle id="delete-visit-modal-title">
                {t('admin:deleteVisit')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={onClose}
                    data-testid="close-dialog"
                />
            </DialogTitle>

            <DialogContent className="delete-visit-warning-content">
                <div className="delete-visit-text">{t('admin:deleteVisitWarning')}</div>
            </DialogContent>
        </CustomDialog>
    );
};

export default DeleteVisitWarningDialog;
